import React from "react";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import { useLeaveBalanceByEmployee } from "../hooks/useEmployee";

interface LeaveBalanceListProps {
  // Define any props if needed
  Employee: Record<string, any>;
}

const LeaveBalanceList: React.FC<LeaveBalanceListProps> = ({ Employee }) => {
  const { data: LeaveBalance } = useLeaveBalanceByEmployee({
    enabled: !!Employee.EmployeeId,
    params: {
      employee_id: Employee.EmployeeId,
    },
  });

  console.log("leave balance", LeaveBalance?.data);

  const LeaveBalanceColumns = [
    {
      name: "Type",
      selector: (row: { type: string }) => row.type,
      sortable: true,
    },
    {
      name: "Emp Code",
      selector: (row: { employeeCode: string }) => row.employeeCode,
      sortable: true,
      minWidth:'130px'
    },
    {
      name: "Leave year",
      selector: (row: { leaveyear: string }) => row.leaveyear,
      sortable: true,
          minWidth:'130px'
    },
    {
      name: "Balance",
      selector: (row: { balance: number }) => row.balance,
      sortable: true,
    },
  ];

  const formatLeaveBalance = () => {
    const data = LeaveBalance?.data?.data || [];
    const filteredData = data.filter((item: any) => item.LeaveType !== "LWP");
    return filteredData.map((item: any, index: number) => ({
      type: item.LeaveType,
      leaveyear: item.LeaveYear,
      balance: item.Balance,
      employeeCode:item.employeeCode,
      raw: item,
    }));
  };

          const handleLeaveBalanceExcel = async () => {
  try {
    const appToken = localStorage.getItem("Apptoken") || "";
    const params = new URLSearchParams({
      employee_id:  Employee.EmployeeId,
    });

    const response = await fetch(
      `https://tspc-development.truesales.in/admin/api/getLeaveBalanceByEmployeeExcel?${params.toString()}`,
      {
        method: "GET",
        headers: {
          accept: "application/json",
          apptoken: appToken,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to download Excel file");
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "LeaveBalanceData.xlsx"; // custom filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading Excel file:", error);
  }
};

  return (
    <div>
      <BasicDataTable
      pagination={false}
        Title="Leave Balance"
        columns={LeaveBalanceColumns}
        data={formatLeaveBalance()}
        search={false}
        topLeftAlignContent={
          <>
            {" "}
            <button
              className="btn btn-primary"
              style={{
                borderRadius: "20px",
                padding: "3px 10px",
                width: "fit-content",
              }}
              onClick={handleLeaveBalanceExcel}
            >
              Excel
            </button>
          </>
        }
      />
    </div>
  );
};

export default LeaveBalanceList;
